import {CatalogProductOverviewRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {
    CatalogProductOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductOverviewRestDtoModel";

export class CatalogProductWithImageOverviewRestDtoModel {
    main_image_url: string | undefined;
    product: CatalogProductOverviewRestDto;

    constructor(product: CatalogProductOverviewRestDto, main_image_url: string | undefined = undefined) {
        this.main_image_url = main_image_url;
        this.product = product;
    }

    static createWithDefaults(): CatalogProductWithImageOverviewRestDtoModel {
        return new CatalogProductWithImageOverviewRestDtoModel(CatalogProductOverviewRestDtoModel.createWithDefaults());
    }
}
